/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Formatter, Button, PopOver, Tag, WebRequest,
} from '@cgn/framework-ui-components/v1';
import { PrinterIcon } from '@cgn/framework-ui-components/icons';
import marked from 'marked';
import Enums from '../../Shared/Enums';
import Utils from '../../Shared/Utils';

class Messaggio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allegati: [],
    };
  }

  componentDidMount() {
    const { messaggio, segnaComeLetta } = this.props;
    if (messaggio && segnaComeLetta) {
      segnaComeLetta(messaggio.IdInvio);
    }
  }

  UNSAFE_componentWillReceiveProps(next, nextContext) {
    const { messaggio } = this.props;
    if (next.messaggio && (messaggio == null || messaggio.IdInvio != next.messaggio.IdInvio)) {
      this.setState({ allegati: [] });
      this.allegatiCaricati = false;

      if (next.segnaComeLetta) {
        next.segnaComeLetta(next.messaggio.IdInvio);
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  stampa = () => {
    window.print();
  };

  caricaAllegati = (idMessaggio) => {
    const { baseUrl } = this.props;
    WebRequest.get(`${baseUrl}/Messaggi/Allegati`, { idMessaggio }).then((res) => this.setState({ allegati: res }));
    this.allegatiCaricati = true;
  };

  render() {
    const {
      messaggio, onModaleNuovoQuesitoAperta, profilo, disableStampa,
    } = this.props;
    const { allegati } = this.state;

    if (messaggio && messaggio.HaAllegati && !this.allegatiCaricati) {
      this.caricaAllegati(messaggio.IdMessaggio);
    }

    return messaggio ? (
      <div className={allegati.length > 0 ? 'col messaggio messaggio--allegati' : 'col messaggio'} id="printable">

        <div className="messaggio__intestazione">
          <span>{Enums.Giorni[new Date(messaggio.DataPubblicazione).getDay()]} &nbsp;
            <Formatter valore={messaggio.DataPubblicazione} tipo="date" /> - ore <Formatter valore={messaggio.DataPubblicazione} tipo="hour" />
          </span>
          <strong>Da: {messaggio.Mittente || messaggio.Reparto}</strong>
          <span className="messaggio__oggetto">Oggetto: {messaggio.Titolo}</span>
          {profilo && <span>A: {`${profilo.Nome} ${profilo.Cognome}`}</span>}
          <div className="messaggio__allegati">
            {
              allegati.map((x, i) => (
                <Tag key={i}>
                  <a href={`Messaggi/Allegato?idAllegato=${x.IdAllegato}`}>{x.Nome}</a>
                </Tag>
              ))
            }
          </div>
        </div>

        <div className="messaggio__testo">
          <span dangerouslySetInnerHTML={{ __html: messaggio ? marked(messaggio.Testo) : '' }} onClick={Utils.navigaLink} />

          {messaggio.RispostaAbilitata && (
            <div className="messaggio messaggio__replicaBtn">
              Se desideri ricevere ulteriori informazioni utilizza il bottone sottostante. <br /><br />
              <Button
                primary
                onClick={() => {
                  onModaleNuovoQuesitoAperta?.(
                    {
                      servizio: messaggio.ServizioDiRisposta,
                      categoria: messaggio.CategoriaDiRisposta,
                      oggetto: messaggio.OggettoPredefinitoRisposta,
                      selezioneBloccata: true,
                      idMessaggio: messaggio.idMessaggio,
                    },
                  );
                }}
              >
                Richiedi ulteriori informazioni
              </Button>
            </div>
          )}
        </div>
        {!disableStampa
          && (
            <div className="messaggio messaggio__stampaBtn">
              <PopOver bottom content="Stampa">
                <Button floating onClick={this.stampa}><PrinterIcon /></Button>
              </PopOver>
            </div>
          )}
      </div>
    ) : <div />;
  }
}

Messaggio.propTypes = {
  baseUrl: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  messaggio: PropTypes.object,
  segnaComeLetta: PropTypes.func,
  onModaleNuovoQuesitoAperta: PropTypes.func,
  profilo: PropTypes.shape({
    Nome: PropTypes.string,
    Cognome: PropTypes.string,
  }),
  disableStampa: PropTypes.bool,
};

Messaggio.defaultProps = {
  baseUrl: '',
  messaggio: undefined,
  profilo: undefined,
  segnaComeLetta: undefined,
  onModaleNuovoQuesitoAperta: undefined,
  disableStampa: false,
};

export default Messaggio;
